<template>
  <div class="main">
    <div class="header">
      <a @click="backLinkClicked()">{{ this.backLinkText }}</a>
    </div>

    <GPSDevice
      :weHuntGPSStorePath="weHuntGPSStorePath"
      :gpsDeviceStorePath="gpsDeviceStorePath"
      :usersCacheStorePath="usersCacheStorePath"
      weHuntGPSRouteName="userDetailsWeHuntGPS"
      @gps-device-deleted="gpsDeviceDeleted"
    />
  </div>
</template>

<script>
import GPSDevice from '@/modules/gps/GPSDevice.vue'

import { RELOAD_GPS_DEVICES, RELOAD_DOG_PROFILES } from './userStore'

export default {
  name: 'UserGPS',

  components: {
    GPSDevice
  },

  props: {
    weHuntGPSStorePath: {
      type: String,
      required: true
    },

    userStorePath: {
      type: String,
      required: true
    },

    gpsDeviceStorePath: {
      type: String,
      required: true
    },

    usersCacheStorePath: {
      type: String,
      required: true
    }
  },

  methods: {
    backLinkClicked() {
      this.$router.go(-1)
    },

    gpsDeviceDeleted() {
      const reoadGPSDevicesAction = `${this.userStorePath}/${RELOAD_GPS_DEVICES}`
      this.$store.dispatch(reoadGPSDevicesAction)

      const reloadDogProfilesAction = `${this.userStorePath}/${RELOAD_DOG_PROFILES}`
      this.$store.dispatch(reloadDogProfilesAction)

      this.$router.go(-1)
    }
  },

  computed: {
    backLinkText() {
      return '<< Back'
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  overflow: auto;
  display: flex;
  flex-direction: column;
}

.header {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;

  a {
    margin-right: 0.75rem;
  }
}
</style>
